import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../redux/Action'

class Header extends React.Component {
  state = {
    isOpen: false
  };
toggle() {
  this.setState({
    isOpen: !this.state.isOpen
  });
}

onBtnLogout = () => {
  localStorage.removeItem('username')
  this.props.logout()
}

render() {
  console.log(this.props.role)

  if(this.props.role === 'admin'){
    return(
      <div>
      <Navbar color="faded" light style={{backgroundColor: '#DC3545'}} expand="md">
        <Link className='navbar-brand' to='./' style={{color: 'white'}}>
            Now Playing
        </Link>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret style={{color: 'white'}}>
                {
                  this.props.role
                  ?
                  this.props.username
                  :
                  'Click Me'
                }
              </DropdownToggle>
                {
                  this.props.role
                  ? 
                  <DropdownMenu right>
                    <Link to='/manage-movies'>
                    <DropdownItem>
                        Edit Movie
                    </DropdownItem>
                    </Link>
                    <Link to='/cart'>
                      <DropdownItem>
                          Cart
                      </DropdownItem>
                    </Link>
                    <Link to='/ts-histories'>
                      <DropdownItem>
                          Transactions History
                      </DropdownItem>
                    </Link>
                    <Link to='/change-password'>
                    <DropdownItem>
                        Change Password
                    </DropdownItem>
                    </Link>
                    <Link to='/Login'>
                    <DropdownItem  onClick={this.onBtnLogout}>
                        Log Out
                    </DropdownItem>
                    </Link>
                  </DropdownMenu>
                  :
                  <DropdownMenu right>
                    <Link to='/login'>
                      <DropdownItem>
                        Login
                      </DropdownItem>
                    </Link>
                  <DropdownItem divider />
                  <Link to='/register'>
                  <DropdownItem>
                    Register
                  </DropdownItem>
                  </Link>
                </DropdownMenu>
                }
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    </div>

    )
  }else{
    return (
      <div>
        <Navbar color="dark" dark expand="md">
          <Link className='navbar-brand' to='./' style={{color: 'white'}}>
              Home
          </Link>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret style={{color: 'white'}}>
                  {
                    this.props.role
                    ?
                    this.props.username
                    :
                    'Click Me'
                  }
                </DropdownToggle>
                  {
                    this.props.role
                    ? 
                    <DropdownMenu right>
                      <Link to='/cart'>
                      <DropdownItem>
                          Cart
                      </DropdownItem>
                      </Link>
                      <Link to='/ts-history'>
                      <DropdownItem>
                          Transactions History
                      </DropdownItem>
                      </Link>
                      <Link to='/change-password'>
                      <DropdownItem>
                          Change Password
                      </DropdownItem>
                      </Link>
                      <Link to='/Login'>
                      <DropdownItem  onClick={this.onBtnLogout}>
                          Log Out
                      </DropdownItem>
                      </Link>
                    </DropdownMenu>
                    :
                    <DropdownMenu right>
                      <Link to='/login'>
                        <DropdownItem>
                          Login
                        </DropdownItem>
                      </Link>
                    <DropdownItem divider />
                    <Link to='/register'>
                    <DropdownItem>
                      Register
                    </DropdownItem>
                    </Link>
                  </DropdownMenu>
                  }
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }

}
}

const mapStatetoProps = ({auth}) => {
  return {
      username: auth.username,
      role: auth.role
  }
}

export default connect(mapStatetoProps, { logout })(Header); 